/**
 * Legacy script for products' terpography chart, cleaned up to use
 * ES6, remove redundant variables and functions, and ensure
 * consistency. This script relies on two external assets, older
 * versions of d3.min.js and nv.d3.min.js, which are loaded
 * separately in snippets/product.terpography.liquid. These CANNOT be
 * imported or required (they will not compile without errors) or
 * replaced with their latest NPM equivalents (or this script will
 * need to be rewritten).
 */
(($) => {
  $(() => {
    const $definitions = $('.product-terpography__definitions');
    const $list = $('.product-terpography__list');
    const $chart = $('.product-terpography__chart');

    if ($list.length && $chart.length) {
      const $collapse = $chart.parents('.collapse');
      const collapsedByDefault = !$collapse.is('.show');

      let chart;

      /**
       * Sorts DL and UL list items (and therefore the order these
       * items appear in the chart) by largest to smallest value.
       */
      (() => {
        const $defs = $definitions.children();
        const $lis = $list.children();

        const sorter = (a, b) => {
          const aValue = parseFloat(a.dataset.value);
          const bValue = parseFloat(b.dataset.value);

          if (aValue > bValue) {
            return -1;
          } else if (aValue < bValue) {
            return 1;
          } else {
            return 0;
          }
        };

        $defs.sort(sorter).detach().appendTo($definitions);
        $lis.sort(sorter).detach().appendTo($list);
      })();

      /**
       * Complex function for updating positioning and alignment of
       * chart labels to ensure they do not overlap the chart or
       * each other. Also handles showing/hiding the .collapse that
       * contains the chart to ensure the calculations are correct.
       */
      const updateChartLabels = () => {
        const collapsed = !$collapse.is('.show');

        if (collapsed) $collapse.addClass('show');

        chart.update();

        const offsetThreshold = 50;
        const yPositions = [];

        $chart.find('.nv-label').each((index, element) => {
          const $label = $(element);

          if (!$label.data('original-transform')) {
            $label.data('original-transform', $label.attr('transform'));
          }

          let transform = $label.data('original-transform');

          transform = transform
            .substring(transform.indexOf('(') + 1, transform.indexOf(')') - 1)
            .split(',')
            .map((i) => parseFloat(i));

          const x = transform[0];
          const oldY = transform[1];
          let newY = oldY - 15 * Math.sign(oldY);

          yPositions.forEach((prevY) => {
            if (Math.abs(prevY - newY) <= 30) {
              newY = prevY - 15 * Math.sign(oldY) + 30 * Math.sign(oldY);
            }
          });

          $label.attr('transform', 'translate(' + x + ',' + newY + ')');

          yPositions.push(newY);

          let textAnchor = 'middle';

          if (x > offsetThreshold) {
            textAnchor = 'start';
          } else if (x < -offsetThreshold) {
            textAnchor = 'end';
          }

          $label.find('text').css('text-anchor', textAnchor);

          if (collapsed) $collapse.removeClass('show');
        });
      };

      const chartColors = [
        '#1276ca',
        '#0e60a5',
        '#0a4372',
        '#073255',
        '#052139',
        '#000000',
        '#4b4b4b',
        '#767676',
        '#b5b5b5',
        '#d5d5d5',
      ];

      const chartData = [];

      $list.children('li').each((index, element) => {
        const $li = $(element);
        const key = $li.data('key');
        const label = $li.data('label');
        const value = parseFloat($li.data('value'));
        const $icon = $li.children('.product-terpography__list-icon');

        $icon.css('background-color', chartColors[index]);

        if (value > 0)
          chartData.push({
            key: key,
            label: label,
            value: value,
          });
      });

      const chartLabels = [];
      const chartDataset = {
        data: [],
      };

      chartData.forEach((data) => {
        chartLabels.push(data.label);
        chartDataset.data.push(data.value);
      });

      nv.addGraph(() => {
        chart = nv.models
          .pieChart()
          .x((d) => d.label)
          .y((d) => d.value)
          .showLabels(true)
          .showLegend(false)
          .labelThreshold(0)
          .labelType('key')
          .donut(true)
          .donutRatio(0.6)
          .labelsOutside(true)
          .padAngle(0.01)
          .growOnHover(false)
          .color(chartColors);

        chart.tooltip.enabled(false);

        if (collapsedByDefault) $collapse.addClass('show');

        d3.select('.product-terpography__chart svg').datum(chartData).call(chart);

        updateChartLabels();

        nv.utils.windowResize(updateChartLabels);

        if (collapsedByDefault) $collapse.removeClass('show');

        return chart;
      });
    }
  });
})(jQuery);
